import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOMeta from '@/components/feature/SEOMeta';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Hitozuma 专题导览',
    url: window.location.origin,
    description:
      '围绕 hitozuma 主题展开深度内容解析，为对 hitozuma 文化、相关作品及背景有浓厚兴趣的成年用户提供全面、专业的信息导览与资源索引。',
    inLanguage: 'zh-CN',
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Hitozuma 专题导览',
    url: window.location.origin,
    description:
      '致力于为 hitozuma 文化研究者和爱好者提供全面、专业的内容导览与资源索引。',
  };

  return (
    <>
      <ScrollToTop />
      <SEOMeta
        title="Hitozuma 专题落地页 | 深度内容解析 - Hitozuma 专题导览"
        description="本页围绕 hitozuma 主题展开深度内容解析，为对 hitozuma 文化、相关作品及背景有浓厚兴趣的成年用户提供全面、专业的信息导览与资源索引，帮助您快速了解 hitozuma 的定义、分类与延伸内容。"
        keywords="hitozuma,hitozuma 作品,hitozuma 文化背景,hitozuma 相关资源,hitozuma 分类解析,hitozuma 入门指南,hitozuma 内容导览"
        canonicalUrl="/"
        ogImage="https://readdy.ai/api/search-image?query=Elegant%20Japanese%20cultural%20atmosphere%20warm%20ambient%20lighting%20traditional%20room%20modern%20elements%20soft%20beige%20cream%20warm%20brown%20tones%20artistic%20abstract%20composition&width=1200&height=630&seq=og-home-hitozuma&orientation=landscape"
        schema={websiteSchema}
      />
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>

      <Navbar />

      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedArticles />
        <FAQSection />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}